import common from './common.json';
import forms from './forms.json';
import agents from './agents.json';
import clients from './clients.json';
import entities from './entities.json';
import sidebar from './sidebar.json';
import contacts from './contacts.json';
import activities from './activities.json';
import plannedActivities from './planned-activities.json';
import opportunities from './opportunities.json';

export const en = {
  translation: common,
  forms,
  agents,
  entities,
  sidebar,
  clients,
  contacts,
  activities,
  plannedActivities,
  opportunities,
};
